import { render, staticRenderFns } from "./add-complex-menu-variant-dish-modal.vue?vue&type=template&id=00b26e5e&scoped=true&"
import script from "./add-complex-menu-variant-dish-modal.vue?vue&type=script&lang=ts&"
export * from "./add-complex-menu-variant-dish-modal.vue?vue&type=script&lang=ts&"
import style0 from "./add-complex-menu-variant-dish-modal.vue?vue&type=style&index=0&id=00b26e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b26e5e",
  null
  
)

export default component.exports